import React, { useEffect, memo, useCallback } from "react";
import { Menu, Dropdown, Avatar } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  MehOutlined,
  FormOutlined,
  LogoutOutlined,
  LoadingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import Icon from "components/util-components/Icon";

import * as moment from "moment";
import { Link } from "react-router-dom";

const menuItem = [
  {
    title: "My Profile",
    icon: UserOutlined,
    path: "/app/my-profile",
  },
  {
    title: "Sign Out",
    icon: LogoutOutlined,
    path: "/auth/login",
  },
];

export const NavProfileMenu = (props) => {
  const getCurrentTime = () => {
    return moment().format("dddd, DD MMMM YYYY");
  };

  const profileImg = "/img/avatars/thumb-1.jpg";
  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <Link to={el.path}>
                  <Icon className="mr-3" type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </Link>
              </Menu.Item>
            );
          })}
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu  style={{backgroundColor:"#2f6fe000"}} className="d-flex align-item-center gap-2" mode="horizontal">
        <Menu.Item className="mt-1">
          <Avatar style={{backgroundColor:"white",marginTop:"15px"}} src="/img/avatars/icon.jpg" />
        </Menu.Item>
        <Menu.Item className="p-0 m-0">
          <div className="mt-3" style={{ lineHeight: 1.3,color:"white" }} >
            <small className="mb-0">
              {getCurrentTime()}
            </small>
            <h4 className="mb-0" style={{color:"white"}}>
              <span className="font-weight-normal">Welcome,</span>{" "}
              <b>{localStorage.getItem("first_name")}</b>
            </h4>
          </div>
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
};

export default memo(NavProfileMenu);
